import { v4 as uuid } from 'uuid';
import {
    getOptinAPI,
} from './api';

async function getOptins () {
    const env = this.env;
    const apiKey = this.widgetSettings.apikey;

    let locale = this.locale || 'en';
    if ( this.widget?.language && this.widget?.language !== 'auto') {
        locale = this.widget?.language;
    }

    const res = await getOptinAPI({
        apiKey,
        widgetId: this.widget.id,
        traceId: env.traceId,
        locale,
        store: this,
    });
    this.optins = res.data['optin-messages'];

    this.optins = this.optins.sort((a, b) => {
        return ('' + a.ordinal).localeCompare(b.ordinal);
    });

    this.observed.optins = uuid();
}

export default getOptins;
